import { Backdrop, CircularProgress } from "@mui/material";

const LocalLoading = ({ loading = true }) => {
  return (
    <Backdrop open={loading} sx={{ color: "#fff", backgroundColor: "rgba(0, 0, 0, 0.1)", zIndex: (t) => t.zIndex.modal + 1 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
export default LocalLoading;
